import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class ActivityTasksDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {}, meta = {} } = params;
    const sort = JSON.stringify(params.sort);

    // 构建查询参数
    const searchParams = new URLSearchParams({
      sort,
      page: page.toString(),
      size: perPage.toString(),
      query: JSON.stringify(filter),
      ...meta,
    });

    // 构建请求 URL
    const url = `${baseUrl}/activity/adminGetAllTaskCategories?${searchParams.toString()}`;

    try {
      const { json } = await httpClient(url);

      // 根据您的数据结构处理数据
      // 这里假设您的 API 返回格式可能不同，需要特殊处理
      let rows: any[] = [];
      let total = 0;

      // 根据实际 API 响应结构调整
      if (json?.data) {
        rows = json.data;
        total = json.total || json.data.length;
      } else if (json?.tasks) {
        rows = json.tasks;
        total = json.total || json.tasks.length;
      } else if (Array.isArray(json)) {
        rows = json;
        total = json.length;
      } else {
        // 默认处理
        rows = json?.list ?? json?.items ?? json?.records ?? [];
        total = json?.total ?? json?.count ?? rows.length;
      }

      // 确保每条记录都有 id
      const data = rows.map((r: any, i: number) =>
        r?.id != null ? r : { id: `${i}`, ...r }
      );

      return { data, total };
    } catch (error) {
      console.error('ActivityTaskCategoriesDataProvider getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    // 仅拦截 activity/tasks 列表对应的创建
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/createTaskCategory`;
    const payload = params?.data ?? {};

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/updateTaskCategory`;
    const payload = params?.data ?? {};
    console.log('ActivityTasksDataProvider update payload:', params);

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-task-category') return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/deleteTaskCategory`;
    const payload = { taskId: params?.id ?? params?.previousData?.id };

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json ?? { id: payload.taskId } };
  }
}

// 创建实例并导出
export const activityTaskCategoriesDataProvider = new ActivityTasksDataProvider();
